import { useState } from "react";

import { NumericFormat, NumericFormatProps } from "react-number-format";

interface CurrencyInputProps extends NumericFormatProps {
    error?: boolean;
    //[key: string]: any; // To allow other props
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({ error = false, width = '50%', decimalScale = 2, ...rest }) => {
    const [isFocused, setIsFocused] = useState(false);

    const inputStyles: React.CSSProperties = {
        width,
        height: '2.5rem',
        fontSize: '1rem',
        padding: '0 1rem',
        borderRadius: '0.375rem',
        outline: '2px solid transparent',
        outlineOffset: '2px',
        position: 'relative',
        transition: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
        border: error === true ? '2px solid red' : (isFocused ? '2px solid blue' : '1px solid #e5e7e9'),
    };

    return (
        <NumericFormat
            {...rest}
            thousandSeparator={true}
            decimalScale={decimalScale}
            allowNegative={false}
            style={inputStyles}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
        />
    );
};

export default CurrencyInput;
